import request from '@/utils/request'

// 查询报价计算合伙人列表
export function listDocQuotationReceiver(query) {
  return request({
    url: '/system/docQuotationReceiver/list',
    method: 'get',
    params: query
  })
}

// 查询报价计算合伙人详细
export function getDocQuotationReceiver(id) {
  return request({
    url: '/system/docQuotationReceiver/' + id,
    method: 'get'
  })
}

// 新增报价计算合伙人
export function addDocQuotationReceiver(data) {
  return request({
    url: '/system/docQuotationReceiver',
    method: 'post',
    data: data
  })
}

// 修改报价计算合伙人
export function updateDocQuotationReceiver(data) {
  return request({
    url: '/system/docQuotationReceiver',
    method: 'put',
    data: data
  })
}

// 删除报价计算合伙人
export function delDocQuotationReceiver(id) {
  return request({
    url: '/system/docQuotationReceiver/' + id,
    method: 'delete'
  })
}

// 导出报价计算合伙人
export function exportDocQuotationReceiver(query) {
  return request({
    url: '/system/docQuotationReceiver/export',
    method: 'get',
    params: query
  })
}

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/docQuotationReceiver.js